/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import React from 'react';
import TreeMapNodeTooltip from './TreeMapNodeTooltip';
export var getNodeHandlers = function getNodeHandlers(node, _ref) {
  var isInteractive = _ref.isInteractive,
      _onClick = _ref.onClick,
      showTooltip = _ref.showTooltip,
      hideTooltip = _ref.hideTooltip,
      theme = _ref.theme;
  if (!isInteractive) return {};

  var handleTooltip = function handleTooltip(e) {
    showTooltip(React.createElement(TreeMapNodeTooltip, {
      node: node,
      theme: theme
    }), e);
  };

  return {
    onMouseEnter: handleTooltip,
    onMouseMove: handleTooltip,
    onMouseLeave: hideTooltip,
    onClick: function onClick(event) {
      return _onClick(node, event);
    }
  };
};